import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Button, Box, makeStyles } from '@material-ui/core';
import HomeButton from './HomeButton';
import BreadrcrumbButton from './BreadcrumbButton';


export default function Breadcrumbs(props) {
    const { fileSystemNodePath, setSelectedFileSystemNodePath } = props;

    let partialPath = [];
    let slashConcatenatedFileSystemNodePath = fileSystemNodePath.join('/');
    const breadcrumbs = fileSystemNodePath.map((subpath) => {
        partialPath.push(subpath);
        let slashConcatenatedBreadcrumbPath = partialPath.join('/');
        return <BreadrcrumbButton isActivePage={slashConcatenatedBreadcrumbPath == slashConcatenatedFileSystemNodePath} key={slashConcatenatedBreadcrumbPath} variant="text" fileSystemNodePath={[...partialPath]} fileSystemNodeType={'directory'} setSelectedFileSystemNodePath={setSelectedFileSystemNodePath} directoryName={subpath}/>;
    })
    return (
        <Box p={1} bgcolor={'background.paper'} borderColor={'primary'} border={1} borderRadius={'borderRadius'} borderColor={'#e0e0e0'}>
            <MuiBreadcrumbs>
                <HomeButton setSelectedFileSystemNodePath={setSelectedFileSystemNodePath}/>
                {breadcrumbs}
            </MuiBreadcrumbs>
        </Box>
    );
}